import { render } from "./CatalogCardContainer.vue?vue&type=template&id=5db237a5&scoped=true"
const script = {}

import "./CatalogCardContainer.vue?vue&type=style&index=0&id=5db237a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db237a5"]])

export default __exports__